import { render, staticRenderFns } from "./NewTicketSupport.vue?vue&type=template&id=6d33bf4e&scoped=true&"
import script from "./NewTicketSupport.vue?vue&type=script&lang=js&"
export * from "./NewTicketSupport.vue?vue&type=script&lang=js&"
import style0 from "./NewTicketSupport.vue?vue&type=style&index=0&id=6d33bf4e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d33bf4e",
  null
  
)

export default component.exports